const TIKTOK_BASE_SCRIPT_ID = 'tiktok-pixel-base';

/**
 * Injeta o script base do TikTok Pixel (apenas uma vez)
 */
const ensureTikTokBaseLoaded = (): void => {
  if (document.getElementById(TIKTOK_BASE_SCRIPT_ID)) return;
  if (typeof window !== 'undefined' && (window as any).ttq) return;

  const baseScript = `
    !function(w,d,t){
      w.TiktokAnalyticsObject=t;
      var ttq=w[t]=w[t]||[];
      ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
      ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
      for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
      ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
      ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var s=document.createElement("script");s.type="text/javascript",s.async=!0,s.src=r+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(s,a)};
    }(window,document,'ttq');
  `;

  const script = document.createElement('script');
  script.id = TIKTOK_BASE_SCRIPT_ID;
  script.innerHTML = baseScript;
  document.head.appendChild(script);
};

/**
 * Inicializa o TikTok Pixel para um Pixel Code
 */
export const initializeTikTokPixel = (pixelCode: string): boolean => {
  if (!pixelCode) return false;

  try {
    ensureTikTokBaseLoaded();
    const ttq = (window as any).ttq;
    if (ttq) {
      ttq.load(pixelCode);
      // multi-pixel safe: evita page() global duplicar em loop
      if (typeof ttq.instance === 'function') {
        ttq.instance(pixelCode).page();
      } else {
        ttq.page();
      }
    }
    return true;
  } catch (error) {
    console.error(`❌ TikTok Pixel - Erro ao inicializar ${pixelCode}:`, error);
    return false;
  }
};
